// --- DOM & UI EVENTS (All Disabled) ---

// Disables patching of all DOM events.
(window as any).__Zone_disable_events = true;

// A more targeted way to disable high-frequency events. Redundant if the above is true, but safe to include.
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  'scroll',
  'mousemove',
  'mouseenter',
  'mouseleave',
  'mouseover',
  'mouseout',
  'resize',
  'click',
];

// Disables patching of 'on-property' handlers (e.g., body.onclick).
(window as any).__Zone_disable_on_property = true;

// --- BROWSER APIs (Mostly Disabled) ---

// Disables patching of requestAnimationFrame, a major source of overhead.
(window as any).__Zone_disable_requestAnimationFrame = true;

// Disables patching of media-related APIs.
(window as any).__Zone_disable_mediaQuery = true;
(window as any).__Zone_disable_canvas = true;

// Disables patching for legacy or uncommon APIs.
(window as any).__Zone_disable_geolocation = true;
(window as any).__Zone_disable_blocking = true; // For alert, prompt
(window as any).__Zone_disable_customElements = true;
(window as any).__Zone_disable_MutationObserver = true;
(window as any).__Zone_disable_IntersectionObserver = true;
(window as any).__Zone_disable_FileReader = true;

// __Zone_disable_EventTarget:  // Must be enabled
// __Zone_disable_Promise:      // Must be enabled for async/await context.
// __Zone_disable_timers:       // Must be enabled for setTimeout/setInterval context.
// __Zone_disable_XHR:          // Must be enabled for fetch and XMLHttpRequest tracing.
